























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { goApply } from '@/apps/open/utils'

enum bannerBgEnum {
  'kdocs' = 'kdocs_banner_bg',
  'third-party_enterprise_app' = 'third_enterprise_banner_bg',
  'enterprise_inner_app' = 'enterprise_inner_bg',
  'docs_format_conversion' = 'doc_transform_bg',
  'docs_online_edit' = 'doc_edit_bg'
}

interface infoType {
  title: string,
  desc: string,
  doc_link: string,
  apply_link?: string
}

@Component
export default class TopDetailInfo extends Vue {
  @Prop()
  info!: infoType

  jumpLink (url: string) {
    window.open(url)
  }

  jumpHome () {
    this.$router.push({ name: 'home' })
  }

  goApply () {
    goApply(this.info.apply_link as string | undefined)
  }

  get bannerBg () {
    return bannerBgEnum[this.$route.query.id as any]
  }

  get canShowDocBtn () {
    return this.info.title !== '第三方企业应用'
  }
}
